//REACTSELECT
import React from "react";
import AsyncSelect from "react-select/async";
import { FormField } from "react-form";
import Typography from "@material-ui/core/Typography";


class SelectWrapper extends React.Component {
    handleChange = (event) => {
        const { fieldApi, eventHandle, ormProposalPastOHFCreate, proposal } = this.props;
        const { setValue, setTouched } = fieldApi;

        setTouched();
        if (!event || event.length === 0) {
            //removal case for 'drop down' & 'multiselect' case
            setValue("");
            if (eventHandle) eventHandle("");
            return;
        }
        //multicase save--sets 1 or more selections
        if (event.label) {
            ormProposalPastOHFCreate({ proposal: proposal.id, label: event.label, funds_recommended: event.funds_recommended, latest_spent: event.latest_spent })
        }
    };

    //input = value user types in, callback will fire after we get data and pass back to dropdown window, when user selects will be passed to handleChange function
    loadOptions = (inputValue, callback) => {
        clearTimeout(this.typingTimer);
        this.typingTimer = setTimeout(function () {
            return fetch(`quicksearch/filter?t=${Date.now()}&inputValue=${inputValue}`)
                .then((result) => result.json())
                .then((data) => {
                    callback(data);
                });
        }, 1000);
    };

    loadMessage = (e) => {
        return "Type to Load Projects";
    };

    render() {
        const { fieldApi, classes, label, options, section, formSelection, repeatable, dropDownAutoLoad, ...rest } = this.props;

        var value = fieldApi.getValue();
        if (typeof value === "string") {
            var hit = value.split(","); //convert to array
        }

        //logic for setting the output value that will be seen on the screen
        var obj = {}; //obj used to encapsulate the object for outputting with selects 'defaultValue' prop

        if (value === "") {
            //nothing was selected output on screen
            obj = null;
        } else if (value && hit) {
            //all previously saved, load into and object 'obj' to be outputted in selects 'defaultValue' prop
            obj = hit.map((val) => {
                if (val) {
                    let temp = {};
                    temp.value = val;
                    temp.label = val;
                    temp.color = "#3b7dd4";
                    return temp;
                }
                return null;
            });
        } else {
            //needed for inital render but check other cases first
            obj = null;
        }

        //this is used for advancedSearch Field setups, it uses an 'id' and 'label' for each saved value to be rendered.
        var defaultVal = [];
        if (rest.defaultValue) {
            rest.defaultValue.forEach((v) => {
                var t = {};
                t.value = v.value;
                t.label = v.label;
                t.color = "#3b7dd4";
                defaultVal.push(t);
            });
        }

        return (
            <div>
                {label && <Typography style={{ marginTop: !repeatable ? -8 : 6 }}>{label}</Typography>}

                <AsyncSelect //default case for dropdown field setups, etc.
                    isMulti={rest.isMulti} //allow multiple
                    defaultValue={rest.defaultValue ? defaultVal : obj} //defaultValue is used for when not using form fields. ie when grabbing multiple fields ids
                    isDisabled={rest.disabled}
                    isClearable
                    isSearchable
                    value={dropDownAutoLoad ? obj : null}
                    onChange={this.handleChange} // call local handlechange for normal fields in records, for passing upwards use advancedDialog prop to true
                    name="dropdowns"
                    options={options} //value/label table
                    menuIsOpen={rest.menuIsOpen}

                    loadOptions={this.loadOptions} //async fetching of backend when typed into window
                    noOptionsMessage={this.loadMessage}
                    placeholder={
                        rest.placeholder !== undefined
                            ? rest.placeholder
                            : (dropDownAutoLoad ? "" : "Type to Search")
                    }
                    defaultOptions={dropDownAutoLoad ? true : false} //this triggers autoloading when rendering page--only used for dropdown values from another section
                />
                {rest.required && fieldApi && fieldApi.getError() && (
                    <input //use to allow required to come up on screen
                        tabIndex={-1}
                        value={obj === null ? "Required Field" : ""}
                        style={{
                            opacity: 1,
                            border: 0,
                            color: "#f44336",
                            fontSize: 11,
                            zIndex: 0,
                        }}
                        autoComplete="off"
                    />
                )}
            </div>
        );
    }
}
SelectWrapper.displayName = "SelectWrapper";
const ReactSelect = FormField(SelectWrapper);

export default ReactSelect;
